var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 695,
    height: 489,
    viewBox: "0 0 695 489",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 694.37,
    height: 488.9,
    fill: "#EBF2F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_863_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.809 260.753V238.637H310.78V241.284L300.723 241.242V248.35H308.789V250.997L300.723 250.955V258.147L311.751 258.105V260.753H297.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.076 260.75V238.598H326.99V258.144L337.132 258.102V260.75H324.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.703 260.75V238.598H351.617V258.144L361.753 258.102V260.75H348.697",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.356 243.977L376.964 252.844H385.796L381.362 243.977H381.356ZM389.802 260.793L387.142 255.498H375.691L373.072 260.793H369.947L381.398 237.836L392.891 260.793H389.802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.363 244.607L406.447 260.791H403.533L403.575 237.961L421.572 254.986L421.488 238.591H424.402L424.36 261.584L406.363 244.601",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.663 256.046C438.634 257.18 440.752 258.693 443.75 258.693C446.369 258.693 448.48 257.348 448.48 255.079C448.48 249.406 437.452 250.583 437.452 243.853C437.452 240.113 440.915 238.09 444.589 238.09C447.672 238.09 449.789 239.435 450.797 240.443L449.319 242.46C448.221 241.452 446.616 240.569 444.631 240.569C442.435 240.569 440.534 241.578 440.534 243.721C440.534 248.596 451.605 247.209 451.605 255.073C451.605 258.141 448.734 261.257 443.66 261.257C440.239 261.257 437.114 259.45 436.016 258.021L437.663 256.046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.062 260.753V238.637H477.034V241.284L466.977 241.242V248.35H475.049V250.997L466.977 250.955V258.147L478.005 258.105V260.753H464.062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.618 234.731H465.795L471.412 227.875H475.973L468.618 234.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.104 244.506C250.104 226.922 263.63 212.424 281.096 211.02C281.736 213.229 282.134 215.498 282.309 217.797C282.369 218.638 282.405 219.478 282.405 220.325C282.405 235.117 272.463 248.36 258.231 252.544C258.526 253.475 258.876 254.375 259.262 255.258C274.617 250.641 285.319 236.318 285.319 220.325C285.319 219.4 285.283 218.482 285.211 217.563C284.994 214.664 284.432 211.812 283.534 209.051L283.19 208L282.08 208.054C262.514 208.985 247.184 224.995 247.184 244.506C247.184 247.688 247.6 250.779 248.372 253.721C245.585 253.421 242.912 252.767 240.397 251.806C228.366 247.219 219.914 235.633 219.914 222.114C219.914 219.136 220.324 216.194 221.139 213.361C228.867 213.997 236.053 217.389 241.47 222.984C242.345 223.891 243.178 224.857 243.938 225.86C244.39 224.899 244.879 223.963 245.398 223.044C244.807 222.33 244.203 221.633 243.564 220.973C237.368 214.574 229.048 210.816 220.149 210.395L219.039 210.341L218.695 211.392C217.573 214.844 217 218.452 217 222.114C217 237.512 227.039 250.605 241.09 255.126C243.703 255.966 246.454 256.501 249.301 256.705C254.357 270.842 267.938 281 283.859 281V278.1C265.241 278.1 250.098 263.032 250.098 244.506",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_863_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 73,
    fill: "white",
    transform: "translate(217 208)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox1);
export default __webpack_public_path__ + "static/media/box-1.8a59c31836daa226400d8b393f299891.svg";
export { ForwardRef as ReactComponent };